<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        representanteid: '',
        condicaopagamentoid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      dataFromApiRepresentanteId: '',
      dataFromApiCondicaoPagamentoId: '',
      isLoadingRepresentante: false,
      isLoadingCondicaoPagamento: false,
    };
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromRepresentante();
      this.fetchDataFromCondicaoPagamento();
    },
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
    async fetchDataFromRepresentante() {
      this.isLoadingRepresentante = true;
      try {
        const response = await axios.get('/representante');
        this.dataFromApiRepresentanteId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoadingRepresentante = false;
      }
    },
    async fetchDataFromCondicaoPagamento() {
      this.isLoadingCondicaoPagamento = true;
      try {
        const response = await axios.get('/condicao-pagamento');
        this.dataFromApiCondicaoPagamentoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.isLoadingCondicaoPagamento = false;
      }
    },
  },
};
</script>

<template>
  <!-- :ok-disabled="dataForm.isDefault || dataForm.condicaopagamentoid === ''" -->
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      ok-disabled
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Representante"
                label-for="representanteid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.representanteid"
                    id="representanteid"
                    :state="errors.length > 0 ? false:null"
                    :options="dataFromApiRepresentanteId"
                    value-field="representanteid"
                    text-field="representantenome"
                    placeholder="Digite o id"
                    disabled
                />
                <div v-if="isLoadingRepresentante" class="select-loading-indicator">
                  <b-spinner small variant="primary"></b-spinner>
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Condição Pagamento"
                label-for="condicaopagamentoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.condicaopagamentoid"
                    id="condicaopagamentoid"
                    :state="errors.length > 0 ? false:null"
                    :options="dataFromApiCondicaoPagamentoId"
                    value-field="condicaopagamentoid"
                    text-field="condicaopagamentodescricao"
                    placeholder="Digite o id"
                    disabled
                />
                <div v-if="isLoadingCondicaoPagamento" class="select-loading-indicator">
                  <b-spinner small variant="primary"></b-spinner>
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<style scoped>
.select-loading-indicator {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
</style>
